<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <!-- <home-footer /> -->
  </v-app>
</template>

<script>
export default {
  name: "UserLayout",

  components: {
    HomeAppBar: () => import("@/layouts/user/AppBar"),
    HomeView: () => import("@/layouts/user/View")
  },

  methods: {},

  mounted() {}
};
</script>

<style lang="sass">
html
  overflow-y: auto
</style>

